<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
      </template>
    </c-search-box>
    <c-tree-table
      ref="table"
      title="장소 목록"
      parentProperty="upMdmLocationId"
      customID="mdmLocationId"
      :columns="gridColumns"
      :data="grid.data"
      :gridHeight="grid.height"
      :columnSetting="false"
      :isFullScreen="false"
      :usePaging="false"
      :selection="popupParam.type"
      rowKey="mdmLocationId"
      @rowDblclick="rowDblclick"
        >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="선택" icon="check" @btnClicked="select" />
          <!-- 검색 -->
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-tree-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'locationPop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          plantCd: '',
          isMapShowing: false,
          etcFlag: 'N'
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
        etcFlag: 'N'
      },
      grid: {
        data: [],
        height: '550px',
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    inputEditable() {
      return this.isModify && this.editable;
    },
    gridColumns() {
      let cols = [];
      if (this.popupParam.isMapShowing) {
        cols = [
          {
            name: 'locationName',
            field: 'locationName',
            label: '장소명',
            align: 'left',
            sortable: true,
          },
          {
            name: 'mapName',
            field: 'mapName',
            label: '배치도면명',
            align: 'left',
            sortable: true,
          },
        ]
      } else {
        cols = [
          {
            name: 'locationName',
            field: 'locationName',
            label: '장소명',
            align: 'left',
            sortable: true,
          },
        ]
      }
      return cols;
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.location.list.url;
      // code setting
      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd;
      }
      if (this.popupParam.etcFlag) {
        this.searchParam.etcFlag = this.popupParam.etcFlag;
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '선택된 항목이 없습니다.', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
